import { cancelSubscription, getSubscription, getUserCards, updateSubscription, getUserBalance } from '@/store/actions/subscription';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscriptionData: '',
  subscriptionType: 'month',
  getSubscriptions: [''],
  getSubscriptionsHistory:'',
  getSubscriptionsLoading:false,
  savecallDuration:0,
  loadingPlanShowing:false,
  getAllCardsData:[],
  subscriptionDataAddons:'',
  subscriptionDataWithoutLogin:'',
  balance: 0,
};



// Async thunk action
export const showLoadingPlans: any = createAsyncThunk<any, any>(
  'subscription/loadingPlanShowing',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);


// Async thunk action
export const setCallDuration: any = createAsyncThunk<any, any>(
  'subscription/savecallDuration',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);

// Async thunk action
export const setSubscriptionFormData: any = createAsyncThunk<any, any>(
  'subscription/subscriptionData',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);


// Async thunk action
export const setSubscriptionFormWithoutLogin: any = createAsyncThunk<any, any>(
  'subscription/subscriptionDataWithoutLogin',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);


// Async thunk action
export const setSubscriptionType: any = createAsyncThunk<any, any>(
  'subscription/subscriptionType',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);


// Async thunk action
export const setSubcriptonsAddons: any = createAsyncThunk<any, any>(
  'subscription/subscriptionDataAddons',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);

// Slice with reducers
export const subscriptionSlice = createSlice({
  name: 'subscription', // This should match the slice name (not 'simulation')
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    // If you want to handle async actions (like setSubscriptionFormData) here
    builder
      .addCase(
        setSubscriptionFormData.fulfilled,
        (state: any, { payload }: any) => {
           
           state.subscriptionData = payload;
        },
      )  
      .addCase(
        setSubscriptionFormWithoutLogin.fulfilled,
        (state: any, { payload }: any) => {
           state.subscriptionDataWithoutLogin = payload;
        },
      )  
      
      
      .addCase(
        setSubcriptonsAddons.fulfilled,
        (state: any, { payload }: any) => {
           state.subscriptionDataAddons = payload;
        },
      )

      
      .addCase(
        setCallDuration.fulfilled,
        (state: any, { payload }: any) => {
           state.savecallDuration = payload;
        },
      )
      .addCase(showLoadingPlans.fulfilled, (state: any, { payload }: any) => {
        state.loadingPlanShowing = payload;
      })

      .addCase(getUserCards.fulfilled, (state:any, { payload }: any) => {
        state.getAllCardsData = payload
    })
      .addCase(setSubscriptionType.fulfilled, (state: any, { payload }: any) => {
        state.subscriptionType = payload;
      })


      .addCase(cancelSubscription.pending, (state: any, { payload }: any) => {
         
        state.getSubscriptionsLoading = true
      })

      .addCase(cancelSubscription.rejected, (state: any, { payload }: any) => {
      
        state.getSubscriptionsLoading = false

      })

      .addCase(getSubscription.pending, (state: any, { payload }: any) => {
         
        state.getSubscriptions = payload?.data;
        state.getSubscriptionsHistory = payload?.history;
        state.getSubscriptionsLoading = true
      })
      .addCase(getSubscription.fulfilled, (state: any, { payload }: any) => {
         
        state.getSubscriptions = payload?.data;
        state.getSubscriptionsHistory = payload?.history;
        state.getSubscriptionsLoading = false

      })
      .addCase(getSubscription.rejected, (state: any, { payload }: any) => {
        state.getSubscriptions = payload?.data;
        state.getSubscriptionsHistory = payload?.history;
        state.getSubscriptionsLoading = false

      })
      .addCase(updateSubscription.fulfilled, (state: any, { payload }: any) => {
          
        state.getSubscriptions = [payload?.data]
 
      })
      .addCase(getUserBalance.fulfilled, (state:any, { payload }: any) => {
        state.balance = payload?.balance;
      });  
  },
});

 
// Exporting the reducer
export default subscriptionSlice.reducer;
